import ProductTransformer from './ProductTransformer';

export default class ProductAdministrationConfirmationTransformer extends ProductTransformer {
  static addFootnote(fn, product) {
    if (fn.name === 'footNoteAdministrationConfirmation') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    ['productAdministrationConfirmation', 'productAdministrationConfirmationHint'].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
  }
}
